




























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import OverlayWindow from "../general/OverlayWindow.vue";
import PointerMenu from "../general/PointerMenu.vue";
import ExpandableView from "../controls/ExpandableView.vue";
import HtmlEditor from "../controls/HtmlEditor.vue";
import Loading from "../general/Loading.vue";

import HolidayProgramJson, { HolidayProgramDescriptionAllowedTags } from "../../shared/HolidayProgramJson";
import HolidayProgramPriceJson, { defaultHolidayProgramPriceJson } from "../../shared/HolidayProgramPriceJson";

import Utils from "../../shared/Utils";
import { UserPermissionRank } from "../../shared/UserPermissionRank";
import PriceTemplateManualJson, { PriceTemplateManual } from "../../shared/PriceTemplateManualJson";

import { validateHolidayProgramJson } from "../../shared/HolidayProgramJson";
import { validateHolidayProgramJsonAddNew } from "../../shared/HolidayProgramJson";
import { ValidationResult, Validation } from "../../shared/Validation";

import PriceTemplates from "../custom/PriceTemplates";

type keysForCachedPrices = {
  [key in keyof Pick<HolidayProgramPriceJson, "priceFirstChild" | "priceAdditionalChild" | "cancellationFee">]: string;
};

type keysForPriceTypes = {
  [key in keyof Pick<HolidayProgramJson, "discountPrices" | "addonPrices">]: string;
};

export default Vue.extend({
  name: "HolidaysProgramDetails",
  components: {
    OverlayWindow,
    PointerMenu,
    ExpandableView,
    HtmlEditor,
    Loading,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    programId: Number,
    selectedProgramDetails: Object,
    mode: String,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      Utils: Utils,
      PriceTemplates: PriceTemplates as PriceTemplateManual,
      HolidayProgramDescriptionAllowedTags: HolidayProgramDescriptionAllowedTags,
      defaultHolidayProgramPriceJson: defaultHolidayProgramPriceJson,
      supportsDatePicker: false,
      editable: false as boolean,
      detailsTitle: "",
      UserPermissionRank: UserPermissionRank,
      detailsMode: "",
      selectedTemplateDiscountPrices: {} as { [index: number]: any },
      selectedTemplateAddonPrices: {} as { [index: number]: any },
      cachedDates: {
        beginDate: "",
        endDate: "",
        registrationBeginDateTime: "",
        registrationEndDateTime: "",
      },
      cachedBasePrices: {
        priceFirstChild: "0,00",
        priceAdditionalChild: "0,00",
        cancellationFee: "0,00",
      } as keysForCachedPrices,
      cachedDiscountPrices: [] as keysForCachedPrices[],
      cachedAddonPrices: [] as keysForCachedPrices[],
      selectedProgramId: null as number | null,
      programDetails: null as HolidayProgramJson | null,
      discountPricesStartLength: 0 as number,
      addonPricesStartLength: 0 as number,
      hasChanges: false,
      hintChanged: {
        program: false as boolean,
        staff: false as boolean,
        restrictStaff: false as boolean,
        estimatedChildrenCount: false as boolean,
      },
      toValidate: {} as any,
      validation: null as ValidationResult<HolidayProgramJson> | null,
      submitValidation: false as boolean,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.initHolidaysProgramDetails();
  },
  mounted() {
    this.checkDatePickerSupport();
    this.setCachedDates();
  },
  methods: {
    initHolidaysProgramDetails() {
      this.selectedProgramId = this.programId;

      this.loadProgramDetails();

      this.selectDetailsMode(this.mode);
    },

    setCachedData() {
      this.setCachedBasePrices();
      this.setCachedDiscountPrices();
      this.setCachedAddonPrices();
    },

    checkDatePickerSupport() {
      let testvalue = "a";
      var ele = <HTMLInputElement>this.$refs["testDatePicker"];

      if (ele != null) {
        ele.value = testvalue;

        if (ele.value !== testvalue) {
          this.supportsDatePicker = true;
        }
      }
    },

    async loadProgramDetails() {
      if (this.selectedProgramId != null) {
        this.programDetails = this.selectedProgramDetails;

        this.discountPricesStartLength = this.programDetails!.discountPrices.length;
        this.addonPricesStartLength = this.programDetails!.addonPrices.length;
      } else {
        this.programDetails = {
          ID: null,
          title: "",
          description: "",
          remarks: "",
          beginDate: "",
          endDate: "",
          basePrice: this.getDefaultPrice(),
          discountPrices: [],
          addonPrices: [],
          allowRegistration: false,
          registrationBeginDateTime: "",
          registrationEndDateTime: "",
          registrationMaximumCount: 1,
          waitingListMaximumCount: 0,
          restrictMinimumAge: null,
          restrictMaximumAge: null,
        };

        this.programDetails.basePrice.title = "baseprice";
      }

      this.setCachedData();
      this.hasChanges = false;
    },

    getDefaultPrice(): HolidayProgramPriceJson {
      let defaultPrice = { ...this.defaultHolidayProgramPriceJson() };

      if (this.PriceTemplates.hasOwnProperty("holidaysPrices")) {
        defaultPrice.cancellationRemarks = (
          this.PriceTemplates.holidaysPrices.default as PriceTemplateManualJson
        ).cancellationRemarks;
      }

      return defaultPrice;
    },

    //START set cached data

    setCachedDates() {
      if (this.programDetails != null) {
        let k = this.cachedDates;
        let i: keyof typeof k;

        for (i in this.cachedDates) {
          if (this.programDetails[i] != "") {
            var d = new Date(this.programDetails[i]);

            if (this.supportsDatePicker) {
              this.cachedDates[i] = DateFormatter.formatISODate(d);
            } else {
              if (d != null) {
                this.cachedDates[i] = DateFormatter.formatDateMedium(d);
              }
            }

            //this.cachedDates[i] = this.DateFormatter.formatISODate(new Date(this.programDetails[i]))
          }
        }
      }
    },

    setCachedBasePrices() {
      if (this.programDetails != null) {
        let k = this.cachedBasePrices;
        let i: keyof typeof k;

        for (i in this.cachedBasePrices) {
          this.cachedBasePrices[i] = this.getFormatPrice(this.programDetails.basePrice[i]);
        }
      }
    },

    setCachedDiscountPrices() {
      if (this.programDetails != null) {
        for (let i = 0; i < this.programDetails.discountPrices.length; i++) {
          let prices = {
            priceFirstChild: "0,00",
            priceAdditionalChild: "0,00",
            cancellationFee: "0,00",
          } as keysForCachedPrices;

          let k = prices;
          let j: keyof typeof k;

          for (j in prices) {
            prices[j] = this.getFormatPrice(this.programDetails.discountPrices[i][j]);
          }

          this.cachedDiscountPrices.push(prices);
        }
      }
    },

    setCachedAddonPrices() {
      if (this.programDetails != null) {
        for (let i = 0; i < this.programDetails.addonPrices.length; i++) {
          let prices = {
            priceFirstChild: "0,00",
            priceAdditionalChild: "0,00",
            cancellationFee: "0,00",
          } as keysForCachedPrices;

          let k = prices;
          let j: keyof typeof k;

          for (j in prices) {
            prices[j] = this.getFormatPrice(this.programDetails.addonPrices[i][j]);
          }

          this.cachedAddonPrices.push(prices);
        }
      }
    },

    //END set cached data

    /*
    async reloadBirthdayDetails() {
      if(this.selectedBirthdayId != null) {
        this.birthdayDetails = null
        try {
          this.birthdayDetails = await this.restClient.getBirthdayBooking(
            this.selectedBirthdayId
          )

          this.hasChanges = false
        } catch (e) {
          alert(e.message)
        }
      }
    },
*/

    //discountPrices

    addDiscountPrices() {
      if (this.programDetails != null) {
        this.cachedDiscountPrices.push({
          cancellationFee: "0,00",
          priceFirstChild: "0,00",
          priceAdditionalChild: "0,00",
        });
        this.programDetails.discountPrices.push(this.getDefaultPrice());

        this.markDiscountPriceAsNew();
      }
    },

    deleteDiscountPrice(index: number) {
      if (this.programDetails != null && this.programDetails.discountPrices != null) {
        this.programDetails.discountPrices.splice(index, 1);
        this.cachedDiscountPrices.splice(index, 1);

        delete this.toValidate["discountPrices-" + index];
      }
    },

    markDiscountPriceAsNew() {
      if (this.programDetails != null) {
        let index = this.programDetails.discountPrices.length - 1;
        this.selectedTemplateDiscountPrices[index] = null;
      }
    },

    setTemplateDiscountPriceInfos(discountPriceIndex: number) {
      if (this.programDetails != null) {
        if (
          this.selectedTemplateDiscountPrices[discountPriceIndex] != null &&
          this.PriceTemplates.hasOwnProperty("holidaysPrices")
        ) {
          const templates = this.PriceTemplates.holidaysPrices.discountPrices as PriceTemplateManualJson[];

          this.programDetails.discountPrices[discountPriceIndex].title =
            templates[this.selectedTemplateDiscountPrices[discountPriceIndex]].title;
          this.programDetails.discountPrices[discountPriceIndex].remarks =
            templates[this.selectedTemplateDiscountPrices[discountPriceIndex]].remarks;
          this.programDetails.discountPrices[discountPriceIndex].cancellationRemarks =
            templates[this.selectedTemplateDiscountPrices[discountPriceIndex]].cancellationRemarks;
        } else {
          this.programDetails.discountPrices[discountPriceIndex].title = "";
          this.programDetails.discountPrices[discountPriceIndex].remarks = "";
          this.programDetails.discountPrices[discountPriceIndex].cancellationRemarks = "";
        }
      }
    },

    //addonPrices

    addAddonPrice() {
      if (this.programDetails != null) {
        this.cachedAddonPrices.push({
          cancellationFee: "0,00",
          priceFirstChild: "0,00",
          priceAdditionalChild: "0,00",
        });
        this.programDetails.addonPrices.push(this.getDefaultPrice());

        this.markAddonPriceAsNew();
      }
    },

    deleteAddonPrice(index: number) {
      if (this.programDetails != null && this.programDetails.addonPrices != null) {
        this.programDetails.addonPrices.splice(index, 1);
        this.cachedAddonPrices.splice(index, 1);

        delete this.toValidate["addonPrices-" + index];
      }
    },

    markAddonPriceAsNew() {
      if (this.programDetails != null) {
        let index = this.programDetails.addonPrices.length - 1;
        this.selectedTemplateAddonPrices[index] = null;
      }
    },

    setTemplateAddonPriceInfos(addonPriceIndex: number) {
      if (this.programDetails != null) {
        if (
          this.selectedTemplateAddonPrices[addonPriceIndex] != null &&
          this.PriceTemplates.hasOwnProperty("holidaysPrices")
        ) {
          const templates = this.PriceTemplates.holidaysPrices.addonPrices as PriceTemplateManualJson[];

          this.programDetails.addonPrices[addonPriceIndex].title =
            templates[this.selectedTemplateAddonPrices[addonPriceIndex]].title;
          this.programDetails.addonPrices[addonPriceIndex].remarks =
            templates[this.selectedTemplateAddonPrices[addonPriceIndex]].remarks;
        } else {
          this.programDetails.addonPrices[addonPriceIndex].title = "";
          this.programDetails.addonPrices[addonPriceIndex].remarks = "";
        }
      }
    },

    selectDetailsMode(mode: string) {
      this.resetHintChanged();

      switch (mode) {
        case "add":
          this.detailsMode = "add";
          this.detailsTitle = "Programm hinzufügen";
          this.editable = true;
          break;

        case "edit":
          this.detailsMode = "edit";
          this.detailsTitle = "Programm bearbeiten";
          this.editable = true;
          break;

        default:
          this.detailsMode = "read";
          this.detailsTitle = "Programm";
          this.editable = false;
          break;
      }
    },

    toggleEditMode() {
      this.editable = !this.editable;
    },

    resetHintChanged() {
      let k = this.hintChanged;
      let i: keyof typeof k;

      for (i in this.hintChanged) {
        this.hintChanged[i] = false;
      }
    },

    stopEditMode() {
      if (!this.hasChanges) {
        //todo: use $refs
        document.getElementsByClassName("overlay-window-scroll")[0].scrollTo(0, 0);
        this.selectDetailsMode("show");
        this.selectedTemplateAddonPrices = {};
        this.hasChanges = false;
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          document.getElementsByClassName("overlay-window-scroll")[0].scrollTo(0, 0);
          this.selectDetailsMode("show");
          this.selectedTemplateAddonPrices = {};
        } else {
          //do nothing
        }
      }
    },

    closeDetails() {
      if (!this.hasChanges) {
        this.$emit("closeOverlay");
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.$emit("closeOverlay");
        } else {
          //do nothing
        }
      }
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.programDetails != null) {
        this.validation = validateHolidayProgramJson(this.programDetails);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    //START set input data (where data be cached)

    setBeginDate() {
      if (this.programDetails != null) {
        var date = "";

        if (this.supportsDatePicker) {
          date = this.cachedDates["beginDate"];
        } else {
          if (this.cachedDates["beginDate"].match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
            let d = DateFormatter.parseDateString(this.cachedDates["beginDate"]);

            if (d != null) {
              date = DateFormatter.formatISODate(d);
            }
          }
        }

        this.programDetails["beginDate"] = date;
      }
    },

    setEndDate() {
      if (this.programDetails != null) {
        var date = "";

        if (this.supportsDatePicker) {
          date = this.cachedDates["endDate"];
        } else {
          if (this.cachedDates["endDate"].match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
            let d = DateFormatter.parseDateString(this.cachedDates["endDate"]);

            if (d != null) {
              date = DateFormatter.formatISODate(d);
            }
          }
        }

        this.programDetails["endDate"] = date;
      }
    },

    setRegistrationBeginDateTime() {
      if (this.programDetails != null) {
        var date = "";

        if (this.supportsDatePicker) {
          date = DateFormatter.formatUSDate(new Date(this.cachedDates["registrationBeginDateTime"]));
        } else {
          if (this.cachedDates["registrationBeginDateTime"].match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
            let d = DateFormatter.parseDateString(this.cachedDates["registrationBeginDateTime"]);

            if (d != null) {
              date = DateFormatter.formatUSDate(d);
            }
          }
        }

        if (isNaN(new Date(date).getTime())) {
          this.programDetails.registrationBeginDateTime = "";
        } else {
          var dateTime = new Date(date);

          if (this.programDetails.registrationBeginDateTime != "") {
            let time = DateFormatter.formatTime(new Date(this.programDetails.registrationBeginDateTime));

            dateTime = new Date(date + " " + time);
          }

          this.programDetails.registrationBeginDateTime = DateFormatter.formatISODateTime(dateTime);
        }
      }
    },

    setRegistrationEndDateTime() {
      if (this.programDetails != null) {
        var date = "";

        if (this.supportsDatePicker) {
          date = DateFormatter.formatUSDate(new Date(this.cachedDates["registrationEndDateTime"]));
        } else {
          if (this.cachedDates["registrationEndDateTime"].match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
            let d = DateFormatter.parseDateString(this.cachedDates["registrationEndDateTime"]);

            if (d != null) {
              date = DateFormatter.formatUSDate(d);
            }
          }
        }

        if (isNaN(new Date(date).getTime())) {
          this.programDetails.registrationEndDateTime = "";
        } else {
          var dateTime = new Date(date);

          if (this.programDetails.registrationEndDateTime != "") {
            let time = DateFormatter.formatTime(new Date(this.programDetails.registrationEndDateTime));

            dateTime = new Date(date + " " + time);
          }

          this.programDetails.registrationEndDateTime = DateFormatter.formatISODateTime(dateTime);
        }
      }
    },

    /*
    setProgramDate<K extends keyof HolidayProgramJson>(index:K) {
      if (this.programDetails != null) {
        var date = ''
        
        if (this.supportsDatePicker) {
          date = this.cachedDates[index]
        } else {
          if (this.cachedEndDate.match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
            let d = DateFormatter.parseDateString(this.cachedEndDate)

            if(d != null) {
              date = DateFormatter.formatISODate(d)
            }
          }
        }

        this.programDetails[index] = date
      }
    },
*/

    formatAndSetCachedBasePrice(key: keyof keysForCachedPrices) {
      if (this.programDetails != null) {
        let price = this.cachedBasePrices[key].replace(".", ",");

        if (!price.includes(",")) {
          price += ",00";
        }

        if (!price.match(/^\d{1,}(,\d{2})?$/)) {
          price = "";
        }

        this.cachedBasePrices[key] = price;
        this.programDetails.basePrice[key] = parseInt(price.replace(/[\D]/g, ""));
      }
    },

    /* setBasePricesFirstChild() {
         if (this.programDetails != null) {
            let price = this.cachedBasePrices["priceFirstChild"].replace(".", ",")

            if (!price.includes(",")) {
               price += ",00"
            }

            if (!price.match(/^\d{1,}(,\d{2})?$/)) {
               price = ""
            }

            this.cachedBasePrices["priceFirstChild"] = price
            this.programDetails.basePrice["priceFirstChild"] = parseInt(price.replace(/[\D]/g, ""))
         }
      },

      setBasePricesAdditionalChild() {
         if (this.programDetails != null) {
            let price = this.cachedBasePrices["priceAdditionalChild"].replace(".", ",")

            if (!price.includes(",")) {
               price += ",00"
            }

            if (!price.match(/^\d{1,}(,\d{2})?$/)) {
               price = ""
            }

            this.cachedBasePrices["priceAdditionalChild"] = price
            this.programDetails.basePrice["priceAdditionalChild"] = parseInt(price.replace(/[\D]/g, ""))
         }
      }, */

    formatAndSetCachedDiscountPrice(index: number, key: keyof keysForCachedPrices) {
      if (index != null && this.programDetails != null) {
        let price = this.cachedDiscountPrices[index][key].replace(".", ",");

        if (!price.includes(",")) {
          price += ",00";
        }

        if (!price.match(/^\d{1,}(,\d{2})?$/)) {
          price = "";
        }

        this.cachedDiscountPrices[index][key] = price;
        this.programDetails.discountPrices[index][key] = parseInt(price.replace(/[\D]/g, ""));
      }
    },

    /* 
      setDiscountPrices(index: any) {
         if (index != null && this.programDetails != null) {
            let k = this.cachedDiscountPrices[index]
            let i: keyof typeof k

            for (i in k) {
               let price = this.cachedDiscountPrices[index][i].replace(".", ",")

               if (!price.includes(",")) {
                  price += ",00"
               }

               if (!price.match(/^\d{1,}(,\d{2})?$/)) {
                  price = ""
               }

               this.cachedDiscountPrices[index][i] = price
               this.programDetails.discountPrices[index][i] = parseInt(price.replace(/[\D]/g, ""))
            }
         }
      }, */

    formatAndSetCachedAddonPrice(index: number, key: keyof keysForCachedPrices) {
      if (index != null && this.programDetails != null) {
        let price = this.cachedAddonPrices[index][key].replace(".", ",");

        if (!price.includes(",")) {
          price += ",00";
        }

        if (!price.match(/^\d{1,}(,\d{2})?$/)) {
          price = "";
        }

        this.cachedAddonPrices[index][key] = price;
        this.programDetails.addonPrices[index][key] = parseInt(price.replace(/[\D]/g, ""));
      }
    },

    /* setAddonPrices(index: any) {
         if (index != null && this.programDetails != null) {
            let k = this.cachedAddonPrices[index]
            let i: keyof typeof k

            for (i in k) {
               let price = this.cachedAddonPrices[index][i].replace(".", ",")

               if (!price.includes(",")) {
                  price += ",00"
               }

               if (!price.match(/^\d{1,}(,\d{2})?$/)) {
                  price = ""
               }

               this.cachedAddonPrices[index][i] = price
               this.programDetails.addonPrices[index][i] = parseInt(price.replace(/[\D]/g, ""))
            }
         }
      }, */

    //END set input data (where data be cached)

    formatAndSetChildrenClassMinimum(priceType: keyof keysForPriceTypes, index: number, value: string) {
      if (this.programDetails != null) {
        if (value == "") {
          this.programDetails[priceType][index].childrenClassMinimum = null;
        } else {
          this.programDetails[priceType][index].childrenClassMinimum = parseInt(value);
        }
      }
    },

    formatAndSetChildrenClassMaximum(priceType: keyof keysForPriceTypes, index: number, value: string) {
      if (this.programDetails != null) {
        if (value == "") {
          this.programDetails[priceType][index].childrenClassMaximum = null;
        } else {
          this.programDetails[priceType][index].childrenClassMaximum = parseInt(value);
        }
      }
    },

    async addNewProgram() {
      if (this.programDetails != null) {
        this.loadingGeneral = true;

        this.validation = validateHolidayProgramJsonAddNew(this.programDetails);

        this.submitValidation = true;

        if (this.validation != null && this.validation.isValid == true) {
          try {
            this.programDetails = await this.restClient.addHolidayProgram(this.programDetails);
            alert("Das Programm wurde erfolgreich hinzugefügt.");
            this.$nextTick(() => {
              this.hasChanges = false;
              this.loadingGeneral = false;
              this.stopEditMode();
            });
          } catch (e) {
            this.loadingGeneral = false;
            alert(e.message);
          }
        } else {
          this.loadingGeneral = false;
          //todo Validation Error anzeigen
          alert("Das Programm konnte nicht hinzugefügt werden. Bitte überprüfen Sie Ihre Angaben.");
        }
      }
    },

    async saveProgramDetails() {
      if (this.programDetails != null) {
        if (this.hasChanges) {
          this.loadingGeneral = true;

          //todo ###START
          //todo: Validation muss durchgeführt werden (siehe hier) ->AUCH bei SettingsDetails
          this.validation = validateHolidayProgramJson(this.programDetails);
          //todo ###END
          if (this.validation != null && this.validation.isValid == true) {
            if (this.restClient != null) {
              try {
                let updatedProgramDetails = await this.restClient.updateHolidayProgram(this.programDetails);

                this.hasChanges = false;
                this.loadingGeneral = false;
                this.stopEditMode();

                //TODO: Validation error loest alert auch aus -> prüfen
                alert("Die Änderungen wurden erfolgreich gespeichert.");
              } catch (e) {
                this.loadingGeneral = false;
                alert(e.message);
              }
            }
          } else {
            this.loadingGeneral = false;
            alert("Die Änderungen konnten nicht gespeichert werden. Bitte überprüfen Sie Ihre Änderungen.");
          }
        } else {
          alert("Es wurden keine Änderungen vorgenommen.");
        }
      }
    },

    async deleteProgram() {
      if (this.selectedProgramId != null) {
        let c = confirm("Wollen Sie dieses Programm wirklich unwiderruflich löschen?");
        if (c == true) {
          if (this.restClient != null) {
            try {
              await this.restClient.deleteHolidayProgram(this.selectedProgramId);
              this.closeDetails();
              alert("Das Programm wurde erfolgreich gelöscht.");
            } catch (e) {
              alert(e.message);
            }
          }
        } else {
          //do nothing
        }
      }
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {
    programDetails: {
      handler(val, oldVal) {
        if (oldVal != null) {
          this.hasChanges = true;
        }
      },
      deep: true,
    },
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    parseRegistrationMaximumCount: {
      get(): number | undefined {
        if (this.programDetails != null) {
          return this.programDetails.registrationMaximumCount;
        }
      },
      set(value: string) {
        if (this.programDetails != null) {
          this.programDetails.registrationMaximumCount = parseInt(value);
        }
      },
    },

    parseWaitingListMaximumCount: {
      get(): number | undefined {
        if (this.programDetails != null) {
          return this.programDetails.waitingListMaximumCount;
        }
      },
      set(value: string) {
        if (this.programDetails != null) {
          this.programDetails.waitingListMaximumCount = parseInt(value);
        }
      },
    },

    parseRestrictMinimumAge: {
      get(): number | null | undefined {
        if (this.programDetails != null) {
          return this.programDetails.restrictMinimumAge;
        }
      },
      set(value: string) {
        if (this.programDetails != null) {
          if (value == "") {
            this.programDetails.restrictMinimumAge = null;
          } else {
            this.programDetails.restrictMinimumAge = parseInt(value);
          }
        }
      },
    },

    parseRestrictMaximumAge: {
      get(): number | null | undefined {
        if (this.programDetails != null) {
          return this.programDetails.restrictMaximumAge;
        }
      },
      set(value: string) {
        if (this.programDetails != null) {
          if (value == "") {
            this.programDetails.restrictMaximumAge = null;
          } else {
            this.programDetails.restrictMaximumAge = parseInt(value);
          }
        }
      },
    },

    formatRegistrationBeginTime: {
      get(): string | undefined {
        if (this.programDetails != null) {
          let d = new Date(this.programDetails.registrationBeginDateTime);
          let time = DateFormatter.formatTime(d);
          if (time == "unbekannt") {
            return "";
          } else {
            return DateFormatter.formatTime(d);
          }
        }
      },
      set(value: string) {
        let time = value.replace(/\D/g, "").replace(/^(\d{2,2})/g, "$1:");

        if (this.programDetails != null && time.match(/^\d{2,2}:\d{2,2}$/g)) {
          if (this.programDetails.registrationBeginDateTime != "") {
            let date = DateFormatter.formatUSDate(new Date(this.programDetails.registrationBeginDateTime));
            this.programDetails.registrationBeginDateTime = DateFormatter.formatISODateTime(
              new Date(date + " " + time)
            );
          }
        }
      },
    },

    formatRegistrationEndTime: {
      get(): string | undefined {
        if (this.programDetails != null) {
          let d = new Date(this.programDetails.registrationEndDateTime);
          let time = DateFormatter.formatTime(d);
          if (time == "unbekannt") {
            return "";
          } else {
            return time;
          }
        }
      },
      set(value: string) {
        let time = value.replace(/\D/g, "").replace(/^(\d{2,2})/g, "$1:");

        if (this.programDetails != null && time.match(/^\d{2,2}:\d{2,2}$/g)) {
          if (this.programDetails.registrationEndDateTime != "") {
            let date = DateFormatter.formatUSDate(new Date(this.programDetails.registrationEndDateTime));
            this.programDetails.registrationEndDateTime = DateFormatter.formatISODateTime(new Date(date + " " + time));
          }
        }
      },
    },
  },
});
